import React from 'react'
import QuestionMatchingForm from './QuestionMatchingForm'
import { rubricPersistSelectors } from '../../../../../../../store/selectors/rubric.persist.selectors'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { useFetchQuestionsQuery } from '../../../../../../../store/apis/question.api'

const QuestionMatchingStep = () => {
    const { token } = useParams()
    const rubricQuestions = useSelector(rubricPersistSelectors.rubricQuestions(token))

    const { data: questions } = useFetchQuestionsQuery({ token })

    return <QuestionMatchingForm originalQuestions={questions} rubricQuestions={rubricQuestions} />
}

export default QuestionMatchingStep
